enum LinkType {
  ADVERT_MEDIA = 'advert_media',
  ADVERT_INTEGRATION = 'advert_integration',
  ADVERT_PARTNER = 'advert_partner',
  EXT_ADVERT_INTEGRATION = 'external_advert_integration',
}
export { LinkType };
